import { Views } from '@neos/app'
import { OpenModeType, PopupPosition } from '@neos/shared'

export const views: Views = {
  default: [
    {
      name: 'AccountUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AccountUI/AccountUI.vue'),
    },
    {
      name: 'AddComputerUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AddComputerUI/AddComputerUI.vue'),
    },
    {
      name: 'AssignPermissionToRolesListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AssignPermissionToRolesListUI/AssignPermissionToRolesListUI.vue'),
    },
    {
      name: 'AssignPermissionToRolesUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AssignPermissionToRolesUI/AssignPermissionToRolesUI.vue'),
    },
    {
      name: 'AuthorizationComputerUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AuthorizationComputerUI/AuthorizationComputerUI.vue'),
    },
    {
      name: 'AuthorizationEditingUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AuthorizationEditingUI/AuthorizationEditingUI.vue'),
    },
    {
      name: 'AuthorizationLicenseUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AuthorizationLicenseUI/AuthorizationLicenseUI.vue'),
    },
    {
      name: 'AuthorizationLogUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AuthorizationLogUI/AuthorizationLogUI.vue'),
    },
    {
      name: 'AuthorizationProductEditingUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AuthorizationProductEditingUI/AuthorizationProductEditingUI.vue'),
    },
    {
      name: 'AuthorizationProductUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AuthorizationProductUI/AuthorizationProductUI.vue'),
    },
    {
      name: 'AuthorizationRevocationUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AuthorizationRevocationUI/AuthorizationRevocationUI.vue'),
    },
    {
      name: 'AuthorizationTenantLicenseUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AuthorizationTenantLicenseUI/AuthorizationTenantLicenseUI.vue'),
    },
    {
      name: 'AuthorizationTenantUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AuthorizationTenantUI/AuthorizationTenantUI.vue'),
    },
    {
      name: 'AuthorizationUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AuthorizationUI/AuthorizationUI.vue'),
    },
    {
      name: 'ComputerUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ComputerUI/ComputerUI.vue'),
    },
    {
      name: 'CountryLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CountryLookupUI/CountryLookupUI.vue'),
    },
    {
      name: 'CultureListUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CultureListUI/CultureListUI.vue'),
    },
    {
      name: 'CurrencyLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CurrencyLookupUI/CurrencyLookupUI.vue'),
    },
    {
      name: 'EventLogDetailUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/EventLogDetailUI/EventLogDetailUI.vue'),
    },
    {
      name: 'EventLogUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/EventLogUI/EventLogUI.vue'),
    },
    {
      name: 'EvoEnterpriseHistoryUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/EvoEnterpriseHistoryUI/EvoEnterpriseHistoryUI.vue'),
    },
    {
      name: 'EvoEnterpriseStatusUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/EvoEnterpriseStatusUI/EvoEnterpriseStatusUI.vue'),
    },
    {
      name: 'EvoEnterprisesUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/EvoEnterprisesUI/EvoEnterprisesUI.vue'),
    },
    {
      name: 'HomePageUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/HomePageUI/HomePageUI.vue'),
    },
    {
      name: 'KnownIanaTimeZoneUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/KnownIanaTimeZoneUI/KnownIanaTimeZoneUI.vue'),
    },
    {
      name: 'MunicipalityLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MunicipalityLookupUI/MunicipalityLookupUI.vue'),
    },
    {
      name: 'NeosBaseUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosBaseUI/NeosBaseUI.vue'),
    },
    {
      name: 'NeosDataExportPropertyUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataExportPropertyUI/NeosDataExportPropertyUI.vue'),
    },
    {
      name: 'NeosDataExportSortsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataExportSortsUI/NeosDataExportSortsUI.vue'),
    },
    {
      name: 'NeosDataExportUI',
      openMode: OpenModeType.popupFullSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataExportUI/NeosDataExportUI.vue'),
    },
    {
      name: 'NeosDataImportColumnMappingEditUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportColumnMappingEditUI/NeosDataImportColumnMappingEditUI.vue'),
    },
    {
      name: 'NeosDataImportColumnMappingListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportColumnMappingListUI/NeosDataImportColumnMappingListUI.vue'),
    },
    {
      name: 'NeosDataImportSettingsUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.right,
      component: () => import('./views/NeosDataImportSettingsUI/NeosDataImportSettingsUI.vue'),
    },
    {
      name: 'NeosDataImportStagingEditUI',
      openMode: OpenModeType.popupFullSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportStagingEditUI/NeosDataImportStagingEditUI.vue'),
    },
    {
      name: 'NeosDataImportStagingListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportStagingListUI/NeosDataImportStagingListUI.vue'),
    },
    {
      name: 'NeosDataImportStagingRowUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportStagingRowUI/NeosDataImportStagingRowUI.vue'),
    },
    {
      name: 'NeosDataImportTargetPropertyLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportTargetPropertyLookupUI/NeosDataImportTargetPropertyLookupUI.vue'),
    },
    {
      name: 'NeosDataImportTemplateEditUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportTemplateEditUI/NeosDataImportTemplateEditUI.vue'),
    },
    {
      name: 'NeosDataImportTemplateListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportTemplateListUI/NeosDataImportTemplateListUI.vue'),
    },
    {
      name: 'NeosDataImportTemplateLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportTemplateLookupUI/NeosDataImportTemplateLookupUI.vue'),
    },
    {
      name: 'NeosDataImportTypeLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosDataImportTypeLookupUI/NeosDataImportTypeLookupUI.vue'),
    },
    {
      name: 'NeosDataImportUploadFileUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.right,
      component: () => import('./views/NeosDataImportUploadFileUI/NeosDataImportUploadFileUI.vue'),
    },
    {
      name: 'PermissionUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/PermissionUI/PermissionUI.vue'),
    },
    {
      name: 'ProductEditingUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ProductEditingUI/ProductEditingUI.vue'),
    },
    {
      name: 'ProductOdooAssociationUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ProductOdooAssociationUI/ProductOdooAssociationUI.vue'),
    },
    {
      name: 'ProductUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ProductUI/ProductUI.vue'),
    },
    {
      name: 'ProvinceStateLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ProvinceStateLookupUI/ProvinceStateLookupUI.vue'),
    },
    {
      name: 'ReportLightPreviewUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ReportLightPreviewUI/ReportLightPreviewUI.vue'),
    },
    {
      name: 'ReportPreviewUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ReportPreviewUI/ReportPreviewUI.vue'),
    },
    {
      name: 'SettingUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/SettingUI/SettingUI.vue'),
    },
    {
      name: 'SoftwareDownloadLinkUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/SoftwareDownloadLinkUI/SoftwareDownloadLinkUI.vue'),
    },
    {
      name: 'SoftwareUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/SoftwareUI/SoftwareUI.vue'),
    },
    {
      name: 'StatisticsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/StatisticsUI/StatisticsUI.vue'),
    },
    {
      name: 'SynchronizationDetailLogUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/SynchronizationDetailLogUI/SynchronizationDetailLogUI.vue'),
    },
    {
      name: 'SynchronizationLogUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/SynchronizationLogUI/SynchronizationLogUI.vue'),
    },
    {
      name: 'SynchronizationUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/SynchronizationUI/SynchronizationUI.vue'),
    },
    {
      name: 'UnitTypeLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UnitTypeLookupUI/UnitTypeLookupUI.vue'),
    },
    {
      name: 'UpdateRevocationDateTimeoutUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UpdateRevocationDateTimeoutUI/UpdateRevocationDateTimeoutUI.vue'),
    },
    {
      name: 'UserAccountAvailableUI',
      openMode: OpenModeType.popupFullSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountAvailableUI/UserAccountAvailableUI.vue'),
    },
    {
      name: 'UserAccountListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountListUI/UserAccountListUI.vue'),
    },
    {
      name: 'UserAccountLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountLookupUI/UserAccountLookupUI.vue'),
    },
    {
      name: 'UserAccountUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountUI/UserAccountUI.vue'),
    },
    {
      name: 'UserAccountUserRoleEntityUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountUserRoleEntityUI/UserAccountUserRoleEntityUI.vue'),
    },
    {
      name: 'UserAccountUserRoleMultiClusterUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountUserRoleMultiClusterUI/UserAccountUserRoleMultiClusterUI.vue'),
    },
    {
      name: 'UserAccountUserRoleUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountUserRoleUI/UserAccountUserRoleUI.vue'),
    },
    {
      name: 'UserPermissionUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserPermissionUI/UserPermissionUI.vue'),
    },
    {
      name: 'UserReportPrintSettingsJobUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserReportPrintSettingsJobUI/UserReportPrintSettingsJobUI.vue'),
    },
    {
      name: 'UserReportPrintSettingsListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserReportPrintSettingsListUI/UserReportPrintSettingsListUI.vue'),
    },
    {
      name: 'UserReportPrintSettingsUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserReportPrintSettingsUI/UserReportPrintSettingsUI.vue'),
    },
    {
      name: 'UserRoleAssignmentUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserRoleAssignmentUI/UserRoleAssignmentUI.vue'),
    },
    {
      name: 'UserSettingsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserSettingsUI/UserSettingsUI.vue'),
    },
    {
      name: 'UserStartupTabUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserStartupTabUI/UserStartupTabUI.vue'),
    },
    {
      name: 'UserTenantListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserTenantListUI/UserTenantListUI.vue'),
    },
    {
      name: 'UserTenantUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserTenantUI/UserTenantUI.vue'),
    },
    {
      name: 'WhatsNewReportUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/WhatsNewReportUI/WhatsNewReportUI.vue'),
    },
  ],
}
